var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "youtube"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29366",
    "data-name": "Rectangle 29366",
    width: 22,
    height: 22,
    transform: "translate(661 1022)",
    fill: "#afaeb7",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_703",
    "data-name": "Mask Group 703",
    transform: "translate(-661 -1022)",
    clipPath: "url(#youtube)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-05-11T145636.100",
    "data-name": "svgexport-6 - 2022-05-11T145636.100",
    transform: "translate(661 1022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12110",
    "data-name": "Path 12110",
    d: "M17.431,3.216H4.569A4.569,4.569,0,0,0,0,7.785v6.43a4.569,4.569,0,0,0,4.569,4.569H17.431A4.569,4.569,0,0,0,22,14.215V7.785A4.569,4.569,0,0,0,17.431,3.216Zm-3.09,8.1L8.325,14.182a.241.241,0,0,1-.345-.218V8.046a.241.241,0,0,1,.351-.215l6.016,3.049A.242.242,0,0,1,14.341,11.313Z",
    fill: "#afaeb7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.af616fd09303449d03f8d64ebec22346.svg";
export { ForwardRef as ReactComponent };